import { render, staticRenderFns } from "./CreateBannerDialog.vue?vue&type=template&id=c0cf6138&lang=pug&"
import script from "./CreateBannerDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateBannerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports